import { CreateBranchDto, DeleteBranchDto, FindBranchesQueryDto, FindBranchesResponse, MergeBranchDto, MergeBranchQueryDto, MergeBranchResponse } from '@/@types/theoryGit/branches';
import { GitApiAxiosBase } from '@/repository/base/axiosBase';

export class BranchesRepository {
  private readonly requestBasePath = 'v1/branches';
  private readonly axios = new GitApiAxiosBase();
  /**ブランチ作成 */
  async createBranch(repositoryInfoId: number, params: CreateBranchDto) {
    const endPoint = `${this.requestBasePath}/${repositoryInfoId}`;
    await this.axios.post(endPoint, params);
  }

  /**ブランチ一覧取得 */
  async findBranches(repositoryInfoId: number, projectId: number) {
    const endPoint = `${this.requestBasePath}/${repositoryInfoId}`;
    const query: FindBranchesQueryDto = {
      'project-id': projectId,
    };
    const response = await this.axios.get<FindBranchesResponse>(
      endPoint,
      { params: query },
    );
    return response.data;
  }

  /**ブランチ削除 */
  async deleteBranch(params: DeleteBranchDto) {
    await this.axios.post(this.requestBasePath, params);
  }

  /**ブランチマージ */
  async mergeBranch(
    repositoryInfoId: number,
    params: MergeBranchDto,
    query: MergeBranchQueryDto
  ) {
    const endPoint = `${this.requestBasePath}/${repositoryInfoId}/merge`;
    const response = await this.axios.post<MergeBranchResponse>(
      endPoint,
      params,
      { params: query },
    );
    return response.data;
  }
}
